import { FOCUS_NO_AUTOFOCUS as o } from "../constants.js";
var d = function(t) {
  if (t.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var e = window.getComputedStyle(t, null);
  return !e || !e.getPropertyValue ? !1 : e.getPropertyValue("display") === "none" || e.getPropertyValue("visibility") === "hidden";
}, u = function(t) {
  return t.parentNode && t.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t.parentNode.host
  ) : t.parentNode;
}, i = function(t) {
  return t === document || t && t.nodeType === Node.DOCUMENT_NODE;
}, s = function(t) {
  return t.hasAttribute("inert");
}, f = function(t, e) {
  return !t || i(t) || !d(t) && !s(t) && e(u(t));
}, l = function(t, e) {
  var r = t.get(e);
  if (r !== void 0)
    return r;
  var n = f(e, l.bind(void 0, t));
  return t.set(e, n), n;
}, c = function(t, e) {
  return t && !i(t) ? T(t) ? e(u(t)) : !1 : !0;
}, v = function(t, e) {
  var r = t.get(e);
  if (r !== void 0)
    return r;
  var n = c(e, v.bind(void 0, t));
  return t.set(e, n), n;
}, N = function(t) {
  return t.dataset;
}, p = function(t) {
  return t.tagName === "BUTTON";
}, a = function(t) {
  return t.tagName === "INPUT";
}, m = function(t) {
  return a(t) && t.type === "radio";
}, A = function(t) {
  return !((a(t) || p(t)) && (t.type === "hidden" || t.disabled));
}, T = function(t) {
  var e = t.getAttribute(o);
  return ![!0, "true", ""].includes(e);
}, E = function(t) {
  var e;
  return !!(t && (!((e = N(t)) === null || e === void 0) && e.focusGuard));
}, y = function(t) {
  return !E(t);
}, O = function(t) {
  return !!t;
};
export {
  N as getDataset,
  T as isAutoFocusAllowed,
  v as isAutoFocusAllowedCached,
  O as isDefined,
  E as isGuard,
  p as isHTMLButtonElement,
  a as isHTMLInputElement,
  y as isNotAGuard,
  m as isRadioElement,
  l as isVisibleCached,
  A as notHiddenInput
};
